/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { useSelector } from "react-redux";
import { RootState } from "store/store";

/**
 * Props for PermissionWrapper component.
 */
interface PermissionWrapperProps {
  children: JSX.Element | null;
  requiredPermissions: string[];
}

/**
 * Component that conditionally renders children based on user permissions.
 * 
 * Features:
 * - Checks user permissions from Redux auth state
 * - Renders children only if user has at least one required permission
 * - Returns null (hides content) if permission check fails
 * - Used for hiding UI elements based on role-based access control
 * 
 * Part of the ISO-27001 compliant access control system.
 * 
 * @param children - React element to conditionally render
 * @param requiredPermissions - Array of permission strings (any match grants access)
 * @returns Children if authorized, null otherwise
 */
const PermissionWrapper = ({ children, requiredPermissions }: PermissionWrapperProps) => {
  const { permissions } = useSelector((state: RootState) => state.auth);

  const hasPermission = requiredPermissions.some((perm) => permissions.includes(perm));
  if (!hasPermission) {
    return null;
  }

  return children;
};

export default PermissionWrapper;
